/**
 * Simple IndexedDB wrapper for persisting user preferences.
 * Survives hard refresh, cache clear, etc.
 */

const DB_NAME = 'busable_user_preferences';
const DB_VERSION = 1;
const STORE_NAME = 'preferences';

let dbPromise = null;

const openDb = () => {
    if (dbPromise) return dbPromise;

    dbPromise = new Promise((resolve, reject) => {
        const request = indexedDB.open(DB_NAME, DB_VERSION);

        request.onerror = () => {
            console.error('Failed to open user preferences DB:', request.error);
            reject(request.error);
        };

        request.onsuccess = () => {
            resolve(request.result);
        };

        request.onupgradeneeded = (event) => {
            const db = event.target.result;
            if (!db.objectStoreNames.contains(STORE_NAME)) {
                db.createObjectStore(STORE_NAME, {keyPath: 'key'});
            }
        };
    });

    return dbPromise;
};

export const getUserPreference = async (key, defaultValue = null) => {
    try {
        const db = await openDb();
        return new Promise((resolve) => {
            const transaction = db.transaction(STORE_NAME, 'readonly');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.get(key);

            request.onsuccess = () => {
                resolve(request.result?.value ?? defaultValue);
            };

            request.onerror = () => {
                console.error('Failed to get preference:', key, request.error);
                resolve(defaultValue);
            };
        });
    } catch (error) {
        console.error('Failed to get preference:', key, error);
        return defaultValue;
    }
};

export const setUserPreference = async (key, value) => {
    try {
        const db = await openDb();
        return new Promise((resolve, reject) => {
            const transaction = db.transaction(STORE_NAME, 'readwrite');
            const store = transaction.objectStore(STORE_NAME);
            const request = store.put({key, value});

            request.onsuccess = () => {
                resolve(true);
            };

            request.onerror = () => {
                console.error('Failed to set preference:', key, request.error);
                reject(request.error);
            };
        });
    } catch (error) {
        console.error('Failed to set preference:', key, error);
        return false;
    }
};
